import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useFavourites } from '../context/FavouritesContext';
import { ProductCard } from '../components/ProductCard';
import { LoadingSpinner } from '../components/LoadingSpinner';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { Heart, ShoppingBag } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FavouritesPage() {
  const { token } = useAuth();
  const { favouriteIds } = useFavourites();
  const [favourites, setFavourites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFavourites();
  }, []);

  const fetchFavourites = async () => {
    try {
      const res = await fetch(`${API}/favourites`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.ok) {
        setFavourites(await res.json());
      }
    } catch (e) {
      console.error('Error fetching favourites:', e);
    } finally {
      setLoading(false);
    }
  };

  // Only show items still saved (reacts to heart toggles via context)
  const visibleFavourites = favourites.filter(p => favouriteIds.has(p.id));

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner text="Loading favourites..." />
      </div>
    );
  }

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-heading font-extrabold flex items-center gap-3">
            <Heart className="w-8 h-8 text-primary" />
            Saved for Later
          </h1>
          <p className="text-muted-foreground mt-2">
            {visibleFavourites.length} saved item{visibleFavourites.length !== 1 ? 's' : ''}
          </p>
        </div>

        {visibleFavourites.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {visibleFavourites.map((product) => (
              <ProductCard 
                key={product.id} 
                product={product}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-primary/10 flex items-center justify-center">
              <Heart className="w-10 h-10 text-primary" />
            </div>
            <h2 className="text-2xl font-heading font-bold mb-2">Nothing saved yet</h2>
            <p className="text-muted-foreground mb-6">
              Tap the heart on any product to save it for later
            </p>
            <Link to="/browse">
              <Button className="btn-brutal-primary">
                <ShoppingBag className="w-5 h-5 mr-2" />
                Browse Products
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
